import React, { Component } from 'react'
import { withStyles } from '@material-ui/core';
import { Switch, Route } from 'react-router-dom'
import Reference from './View/References';


const styles = theme => ({

})

class ReferenceLanding extends Component {
    render() {
        return (
            <div>

                <Switch>
                    <Route exact path="/sponsorreferences" render={(props) =>
                        <Reference
                            {...props}
                            history={this.props.history}
                            username={this.props.username}
                            apikey={this.props.apikey} />
                    } />
                </Switch>
            </div>
        )
    }
}

export default withStyles(styles)(ReferenceLanding)